/// <reference types="./encodeEntityFields.d.ts" />
import { ENCODE_VERSION_AS_IS } from './migrateDecodeAndNormalizeEntityFields.js';
export function encodeEntityFields(fields) {
    return { encodeVersion: ENCODE_VERSION_AS_IS, fields };
}
//# sourceMappingURL=encodeEntityFields.js.map